export default "assets/images/decoration-b3c4444e.svg";